module.exports = __webpack_public_path__ + "static/media/image0.7b2320d3.png";